var exports = {
  "g": "BaseCell__B75CLe",
};

module.exports = exports;
